import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "select" }
const _hoisted_2 = { class: "select-list" }
const _hoisted_3 = ["onClick"]

import { ref } from 'vue';
import { TIcon } from '@tencent/web-vbui';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonSelect',
  props: {
    modelValue: { default: '' },
    selectList: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ((event: 'update:modelValue', val: string) => void), expose: any, slots: any, attrs: any }) {




const isShowSelect = ref(false);

const handleSelect = (val: string) => {
  emit('update:modelValue', val);
  isShowSelect.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "select-main",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowSelect.value = !isShowSelect.value))
    }, [
      _createElementVNode("span", null, _toDisplayString(__props.modelValue), 1),
      _createVNode(_unref(TIcon), {
        "icon-name": "down",
        size: "small"
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["select-item", { active: item.value === __props.modelValue }]),
          key: item.value,
          onClick: ($event: any) => (handleSelect(item.value))
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ], 512), [
      [_vShow, isShowSelect.value]
    ])
  ]))
}
}

})